// extracted by mini-css-extract-plugin
export default {"button__send":"Send_button__send__JrO+m","button__send__disabled":"Send_button__send__disabled__Me2F7"};